/** API DOMAIN URL */
export const {
  REACT_APP_WIKI_SEARCH_API_URL: WIKI_SEARCH_API_URL,
  REACT_APP_SEARCH_API_URL: SEARCH_API_URL,
  REACT_APP_IMG_URL: IMG_URL,
  REACT_APP_IMG_WIKI_URL: WIKI_IMG_URL,
  REACT_APP_WIKI_ADMIN_API_URL: WIKI_ADMIN_URL,
} = process.env;
